// extracted by mini-css-extract-plugin
export var actionRow = "_nf-6";
export var card = "_nf-0";
export var chevron = "_nf-5";
export var content = "_nf-2";
export var details = "_nf-3";
export var eventActionToggle = "_nf-4";
export var icon = "_nf-1";
export var iconBlue = "_nf-8";
export var iconBrand = "_nf-7";
export var iconGrayBlue = "_nf-9";
export var iconGreen = "_nf-a";
export var iconIndigo = "_nf-b";
export var iconOrange = "_nf-c";
export var iconPurple = "_nf-d";
export var iconRed = "_nf-e";
export var iconWarning = "_nf-f";